import { TableCell, Box, styled, Chip } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';

export const TableCellTaskItem = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.5)
}));

export const IconButtonTaskAction = styled(IconButton)(({ theme }) => ({
  borderRadius: '0%',
  margin: theme.spacing(0.2)
}));

export const DocumentLinkBox = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.primary.main,
  display: 'inline'
}));

export const CategoryChip = styled(Chip)(({ theme }) => ({
  marginLeft: theme.spacing(2)
}));